












// @ is an alias to /src

import { Component, Vue } from 'vue-property-decorator';

import {
  Dashboard
} from './dashboard';

import BgStep from '@/assets/BG-Step.svg';

@Component({
  components: {
    Dashboard
  }
})
export default class Home extends Vue {

  bgStep = BgStep;

}
